import type { CertificatePdfData } from '@components/certificate-pdf/index.ts';
import { DATE_FORMATS } from '@constants/date.ts';
import type { CertificateDataResponse } from '@routes/system/certificate/api/certificate.api.ts';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const CERTIFICATE_DATE_FORMAT = DATE_FORMATS.PROFESSIONAL;

export const mapCertificateDataToPdfData = (data: CertificateDataResponse): CertificatePdfData => ({
    pathwayTitle: data.pathwayTitle,
    pathwayVersion: data.pathwayVersion,
    fullName: data.userFullName,
    certificateVersion: data.certificateVersion,
    dateOfBirth: dayjs(data.dateOfBirth).format(CERTIFICATE_DATE_FORMAT),
    nationality: data.userNationality,
    issueDate: dayjs.utc(data.createdAtUTC).format(CERTIFICATE_DATE_FORMAT),
    learningObjectives: data.learningObjectives,
    additionalText: data.additionalCertificateText,
    qrCodeUrl: data.qrCodeUrl,
});

export const getCertificateFileName = (data: CertificatePdfData): string =>
    `${data.fullName}${data.certificateVersion}.pdf`;
